export default function getUserAgentString(): string {
    return typeof navigator != "undefined" && navigator.userAgent ? navigator.userAgent : "";
}
